export default {
    'en': {
        // Auth component
        'token_timeout_info': 'You have been disconnected because your token timed out',
        'login': 'Authentication',
        'register': 'Register',
        'forgot_password': 'Forgot password',
        'login_tab_title': 'Login',
        'register_tab_title': 'Register',
        'forgot_password_tab_title': 'Forgot password',
        'login_by_email_tab_title': 'Login by email',
        'reset_password_title': 'Reset password',
        'login_by_email': 'Please input your email',
        'auth_field_email': 'Email',
        'auth_field_username': 'Username',
        'auth_field_password': 'Password',
        'auth_field_password_confirmation': 'Confirm password',
        'auth_login_button': 'Login',
        'auth_register_button': 'Register',
        'forgot_password_authentication_error_title': 'Authentication error',
        'forgot_password_authentication_success_title': 'Success',
        'forgot_password_button': 'Reset',
        'login_by_email_button': 'Login',
        'login_by_email_info_button': 'Ok',
        'login_by_email_loading_text': 'Trying to connect',
        'login_by_email_email_error': 'Please enter a valid email address',
        'reset_password_button': 'Confirm',
        'login_field_forgot_password': 'Please input your email',
        'login_at_least_one_field_empty': 'Please specify all fields.',
        'login_password_empty': 'The password is not filled.',
        'login_email_incorrect': 'The email is incorrect.',
        'login_error_403': 'Insufficient permissions, please contact an administrator.',
        'login_error_0': 'No response from server.',
        'login_error_401': 'The authentication information provided are incorrect.',
        'login_error_412': 'You are registered. You will receive an email for validation.',
        'login_please_fill_password': 'Please input the password',
        'login_please_fill_email': 'Please input the email',
        'login_please_fill_username': 'Please input the username',
        'login_password_reset_error': 'No account matched this email. Please contact an administrator',
        'login_password_reset_success': ' An email has been sent to your email address with a link to reset your password',
        'login_passwords_dont_match': 'The two passwords do not match!',
        'login_validation_error': 'Validation error',
        'login_please_correct_the_form': 'Please correct the form',
        'login_please_fill_password_again': 'Please input the password again',
        'auth_password_updated': 'Password updated',
        'auth_password_update_error': 'Cannot change password',
        'login_change_password': 'Change password',
        'login_password_expired': 'Password expired',
        'login_password_expired_message': 'Your password has expired. Please input a new password',
        'login_EMAIL_NOT_AUTHORIZED_TO_REGISTER': 'This email is not authorized for registration.',
        'login_EXPIRED_PASSWORD': 'Your password has expired.',
        'login_PASSWORD_INSECURE': 'Your password must contain at least 8 characters, 1 digit, 1 minuscule, 1 uppercase and 1 special character.',
        'login_EMAIL_NOT_VALIDATED': 'Your account is not activated, an activation email has been sent to your mailbox.',
        'login_TOKEN_HAS_EXPIRED': 'Unable to connect, session expired please enter your email to create a new session',
        'login_LOGIN_BY_EMAIL_MAIL_SEND': 'You received an email with a login link',
        'login_INVALID_TOKEN': 'Token invalid.',
        'login_WRONG_EMAIL_ADDRESS': 'The informed email is not authorized to connect to the platform.',
        'login_new_mfa_code_info': 'A new login is required to receive a new code by email',
        'mfa_title': 'Two-factor authentication',
        'mfa_code_input_label': 'Two-factor authentication code',
        'mfa_code_instruction': 'Enter the two-factor authentication code received by email',
        'mfa_code_error': 'Error',
        'mfa_submit_button': 'Verify code',
        'mfa_new_code_button': 'Request a new code',
        'mfa_input_validation_error': 'Please input a code',

        // dashboard layout
        'alert_dismiss': 'Dismiss',
        'header_language_button': 'Language',
        'sidebar_settings_menu': 'Settings',
        'sidebar_alerts_menu': '   Alerts',
        'sidebar_alarms_menu': '    Alarms',
        'sidebar_profile_menu': 'Profile',
        'sidebar_logout_menu': 'Logout',
        'sidebar_users_menu': 'Users',
        'sidebar_groups_menu': 'Groups',
        'sidebar_permissions_menu': 'Permissions',
        'topBarAlert_update': 'An update is available, please refresh the web page or <u class="link" onclick="window.location.reload()">click here</u>',
        'topBarAlert_offline': 'OFFLINE : Unable to connect to the server, please check your internet connectivity',
        'app_loader_text': 'LOADING DATA',
        'page_no_permission': 'You are not allowed to access this page.',

        // alarm component
        'alarm_info_title': 'Details',
        'alarm_last_trigger': 'Last trigger at',
        'alarm_last_trigger_time': 'Last trigger',
        'alarm_last_active_time': 'Active for',
        'alarm_message_title': 'Message',
        'alarm_message_empty': 'No message',
        'alarm_details_title': 'Details',
        'alarm_details_empty': 'No details',
        'alarm_redirection_tooltip': 'Redirect to resource',
        'alarm_redirection_button': 'Go to resource',
        'alarm_redirection_empty': 'No related resource',
        'alarm_simple_layout_breadcrumb': 'Alarms',
        'alarm_simple_layout_active_alarm_indicator': 'active alarms',
        'alarm_simple_layout_inactive_alarm_indicator': 'inactive alarms',
        'alarm_empty': 'No alarm available.',
        'alarm_filter_no_result': 'No alarm for ',
        'alarm_filter_select_option_all': 'All alarms',
        'alarm_filter_select_option_active': 'Active alarms',
        'alarm_filter_select_option_inactive': 'Inactive alarms',
        'alarm_no_permission': 'You are not allowed to access the alarms page.',
        'alarm_notification_message_beginning': 'New alarm',
        'alarm_notification_message_end': 'triggered',

        // alert component
        'alert_simple_layout_breadcrumb': 'Alerts',
        'alert_simple_layout_active_alert_indicator': 'active alerts',
        'alert_simple_layout_inactive_alert_indicator': 'inactive alerts',
        'alert_tab_panel_active_alert_title': 'Active alerts',
        'alert_tab_panel_inactive_alert_title': 'Inactive alerts',
        'alert_tab_panel_archived_alert_title': 'Archived alerts',
        'alert_no_permission': 'You are not allowed to access the alerts pages.',
        'alert_table_label_name': 'Name',
        'alert_table_label_acquitted': 'Acquit time',
        'alert_table_label_triggered': 'Last trigger',
        'alert_table_label_hits': 'Nb of hits',
        'alert_table_label_level': 'Level',
        'alert_table_label_message': 'Message',
        'alert_table_label_event': 'Event',
        'alert_table_event_not_found': 'No related event found',
        'alert_table_label_link': 'Link to resource',
        'alert_table_redirection_tooltip': 'Redirect to resource',
        'alert_table_button_acquit': 'Clear alert',
        'alert_table_button_archive': 'Archive alert',
        'alert_acquit_modal_text': 'Are you sure you want to clear these alerts?',
        'alert_acquit_modal_title': 'Clear alert',
        'alert_acquit_modal_button_confirm': 'Yes',
        'alert_acquit_modal_button_cancel': 'No',
        'alert_acquit_sucessfull': 'Cleared.',
        'alert_acquit_failed': 'Operation cancelled.',
        'alert_archive_modal_text': 'Are you sure you want to archive these alerts?',
        'alert_archive_modal_title': 'Archive alert',
        'alert_archive_modal_button_confirm': 'Yes',
        'alert_archive_modal_button_cancel': 'No',
        'alert_archive_sucessfull': 'Archived.',
        'alert_archive_failed': 'Operation cancelled.',
        'alert_notification_message_beginning': 'New alert',
        'alert_notification_message_end': 'triggered',

        // profile component
        'profile_simple_layout_indicator_title': 'Your profile settings',
        'profile_simple_layout_breadcrumb': 'Profile',
        'profile_arrival_date': 'Joined',
        'profile_identity': 'Identity',
        'profile_identity_form_label_email': 'Email',
        'profile_identity_form_label_first_name': 'First Name',
        'profile_identity_form_label_last_name': 'Last Name',
        'profile_save_button': 'Save',
        'profile_identity_save_successfull_title': 'Edition done',
        'profile_identity_save_successfull_message': 'Your profile has been updated',
        'profile_identity_save_failed_title': 'Edition error',
        'profile_identity_save_failed_message': 'Unable to save profile',
        'profile_manage_notifications': 'Manage notifications',
        'profile_notification_form_label_unsubscribe': 'Unsubscribe from all notifications',
        'profile_notification_form_label_unsubscribe_yes': 'Yes',
        'profile_notification_form_label_unsubscribe_no': 'No',
        'profile_notification_form_label_subscribe': 'Subscribe to',
        'profile_notification_save_successfull_title': 'Notifications updated',
        'profile_notification_save_successfull_message': 'Notifications setting has been updated.',
        'profile_notification_save_failed_title': 'Notifications update error',
        'profile_notification_save_failed_message': 'Unable to save notifications setting.',
        'profile_change_password_title': 'Change password',
        'profile_change_password_button': 'Change password',
        'profile_loading': 'loading...',

        // search view
        'search_result_breadcrumb': 'Search results',
        'search_result_no_result': 'No result.',
        'search_result_loading': 'Loading...',
        'search_result_pagename_single_result': ' result',
        'search_result_pagename_results': ' results',
        'search_result_pagename_no_result': 'No result found',
        'search_result_subtitle': 'Search results for: ',
        'search_result_subtitle_empty_request': 'Nothing searched.',

        // settings view
        'settings_breadcrumb': 'Settings',
        'settings_title': 'Settings',

        // sink handler view (error 404)
        'sink_handler_title': 'Error',
        'sink_handler_text': 'Page not found',
        'sink_handler_loading': 'loading...',

        // partials
        // dynamic form json
        'dynamic_form_json_new': 'Add new',
        'dynamic_form_json_save': 'Save',
        'dynamic_form_json_reset': 'Reset',

        // nsPaginate component
        'ns_paginate_search_title': 'Search filter',
        'ns_paginate_search_placeholder': 'Search data in table',
        'ns_paginate_filters_title': 'Filters',
        'new_ns_paginate_filters_input_placeholder': 'Type to filter by',
        'new_ns_paginate_filters_select_placeholder': 'Select a',
        'ns_paginate_filters_button_reset': 'Reset filters',
        'new_ns_paginate_filters_button_reset': 'Reset',
        'ns_paginate_filters_button_apply': 'Apply filters',
        'new_ns_paginate_filters_button_apply': 'Apply',
        'ns_paginate_advanced_filters_switch_active_text': 'Advanced filters',
        'ns_paginate_advanced_filters_description': 'Advanced filters only accept digits and dates (date format should be YYYY-MM-DD) (2018-10-02). For range filter, numbers must be separated by a comma.',
        'ns_paginate_advanced_filters_title': 'Info',
        'ns_paginate_advanced_filters_placeholder': 'Value to filter',
        'ns_paginate_advanced_filters_compare_placeholder': 'Comparison element',
        'ns_paginate_advanced_filters_compare_gt': 'Greater than',
        'ns_paginate_advanced_filters_compare_gte': 'Greater than or equal to',
        'ns_paginate_advanced_filters_compare_lt': 'Lower than',
        'ns_paginate_advanced_filters_compare_lte': 'Lower than or equal to',
        'ns_paginate_advanced_filters_compare_range': 'In range',
        'ns_paginate_advanced_filters_compare_input_placeholder': 'Comparator value',
        'ns_paginate_advanced_filters_compare_input_tip': 'Numbers must be separated by a comma.',
        'ns_paginate_advanced_filters_error_message_type': 'Input only takes digit or dates values.',
        'ns_paginate_advanced_filters_range_error_message_type': 'Range values must match "YYYY-MM-DD,YYYY-MM-DD" or "x,y" pattern.',
        'ns_paginate_advanced_filters_range_error_message_date': 'First date must be before second.',
        'ns_paginate_advanced_filters_help_text': 'This filter has been ignored as it is incomplete.',
        'ns_paginate_table_column_status_label': 'Status',
        'ns_paginate_table_column_operations_label': 'Operations',
        'ns_paginate_table_column_edit_label': 'Actions',
        'ns_paginate_table_column_edit_tooltip': 'Edit',
        'ns_paginate_table_empty': 'No content',
        'ns_paginate_modal_information_title': 'Informations details',
        'ns_paginate_modal_information_edit_props_error': 'MODEL PROPS MUST BE SETTED FOR PATCH ITEM',
        'ns_paginate_modal_information_edit_success_title': 'Edition done',
        'ns_paginate_modal_information_edit_success_desc': 'Your modifications have been saved',
        'ns_paginate_modal_information_edit_error_title': 'Edition error',
        'ns_paginate_modal_information_edit_error_desc': 'Unable to save modifications',
        'ns_paginate_modal_detail_tooltip_preview': 'Preview',
        'ns_paginate_modal_detail_tooltip_edit': 'Edit',
        'ns_paginate_modal_detail_item_empty': 'Not set',
        'ns_paginate_csv_button': 'Download CSV',

        // waiting button
        'waiting_button_message_confirmation_title': 'Warning',
        'waiting_button_message_confirmation_button': 'OK',
        'waiting_button_message_confirmation_cancel_button': 'Cancel',

        // logs components
        'table_column_label_level': 'Level',
        'table_column_label_date': 'Date',
        'table_column_label_message': 'Message',

        // modal form components
        'modal_form_loading': 'Loading...',
        'modal_form_confirm_button_text': 'Save',

        // ns loader
        'ns_loader_loading': 'loading',
        'ns_loader_content': 'Content',

        // simple layout
        'simple_layout_loading': 'loading...',

        // sort by drag and drop
        'drag_and_drop_tip': 'Drag to reorder',
        'drag_and_drop_error_title': 'Error',
        'drag_and_drop_error_message': 'Error on items reorder',

        // permissions management
        'permissions_simple_layout_breadcrumb': 'Permissions Management',
        'permissions_table_column_label_roles': 'Manage roles',
        'permissions_table_column_label_models': 'Manage models permissions',
        'permissions_alert_no_roles_title': 'No roles available',
        'permissions_alert_no_roles_desc': 'Please create role in left tab',
        'permissions_title': 'Update models permissions roles',
        'permissions_roles_main_column_label': 'Model name',
        'permissions_roles_create_column_label': 'Create roles',
        'permissions_roles_delete_column_label': 'Delete roles',
        'permissions_roles_update_column_label': 'Update roles',
        'permissions_roles_retrieve_column_label': 'Retrieve roles',
        'permissions_save_button': 'Save all permissions',
        'permissions_update_successfull_message': 'Permissions updated',
        'permissions_select_roles': 'Select role(s)',

        'permissions_role_creation_form_title_create': 'Create role',
        'permissions_role_creation_form_title_edit': 'Edit role',
        'permissions_role_creation_form_label_name': 'Role name',
        'permissions_role_creation_form_label_users': 'User with this role',
        'permissions_role_creation_form_transfer_left_label': 'Available users',
        'permissions_role_creation_form_transfer_right_label': 'Selected users',
        'permissions_role_creation_button_cancel': 'Cancel',
        'permissions_role_creation_button_save': 'Save',
        'permissions_role_creation_button': 'Create role',
        'permissions_role_table_column_name': 'Name',
        'permissions_role_table_column_actions': 'Actions',
        'permissions_role_save_successfull_title': 'Success',
        'permissions_role_save_successfull_message_role': 'Role',
        'permissions_role_save_successfull_message_edited': 'edited',
        'permissions_role_save_successfull_message_created': 'created',
        'permissions_role_save_failed_title': 'Error',
        'permissions_role_save_failed_message_role': 'Error on role',
        'permissions_role_save_failed_message_edited': 'edition',
        'permissions_role_save_failed_message_created': 'creation',
        'permissions_user_retrieval_error': 'Error on retrieve users',
        'permissions_role_deletion_title': 'Warning',
        'permissions_role_deletion_message': 'This will permanently delete the role. Continue?',
        'permissions_role_deletion_button_confirm': 'OK',
        'permissions_role_deletion_button_cancel': 'Cancel',
        'permissions_role_deletion_success_title': 'Success',
        'permissions_role_deletion_success_message': 'Role deleted',
        'permissions_role_deletion_failure_title': 'Error',
        'permissions_role_deletion_failure_message': 'Error on role delete',

        // user view
        'user_simple_layout_indicator_subtitle': 'user(s)',
        'user_creation_form_label_email': 'User email',
        'user_creation_form_first_name': 'User first name',
        'user_creation_form_last_name': 'User last name',
        'user_creation_form_label_groups': 'Groups',
        'user_groups_edit_form_label_groups': 'Groups',
        'user_blocked_form_label_groups': 'Blocked users',
        'user_groups_edit_form_transfer_from': 'Available groups',
        'user_blocked_form_transfer_from': 'Blocked users',
        'user_groups_edit_form_transfer_to': 'User groups',
        'user_blocked_form_transfer_to': 'User wich will be un-blocked',
        'user_groups_edit_filter_placeholder': 'Select groups',
        'user_blocked_filter_placeholder': 'Select users',
        'user_groups_edit_validator_error': 'Please apply your changes or uncheck your selection in left and right panel.',
        'user_create_success_title': 'User successfully created',
        'user_edit_form_label_level': 'Level',
        'user_edit_form_label_level_placeholder': 'User level',
        'user_edit_alert_management_not_available': 'You can only manage users with a level strictly inferior to yours.',
        'user_edit_form_label_preview': 'Preview only',
        'user_edit_form_label_preview_active': 'Yes',
        'user_edit_form_label_preview_inactive': 'No',
        'user_edit_form_level_option_superuser': 'Super user',
        'user_edit_form_level_option_admin': 'Admin',
        'user_edit_form_level_option_manager': 'Manager',
        'user_edit_form_level_option_simple': 'Simple user',
        'user_edit_form_level_option_blocked': 'Blocked',
        'user_edit_success_title': 'User updated',
        'user_edit_success_message_beginning': 'User',
        'user_edit_success_message_end': 'has been updated.',
        'user_edit_failure_title': 'Error',
        'user_edit_success_message': 'Error on user update',
        'user_import_modal_uploading': 'Parsing file...',
        'user_import_modal_importing_error': 'Errors while parsing file',
        'user_import_form_label_users': 'Users',
        'user_import_form_label_groups': 'Groups',
        'user_import_help_text': 'Add several users in the same groups by uploading a csv/txt file.',
        'user_import_drop_file_text': 'Drop file here or ',
        'user_import_drop_file_text_emphasized': 'click to upload',
        'user_import_drop_file_tip': 'csv/txt files with a size less than 500kB',
        'user_import_api_not_supported': 'The File APIs are not fully supported in this browser.',
        'user_import_email_not_valid': 'is not a valid email',
        'user_simple_layout_breadcrumb': 'Users Management',
        'user_page_title': 'Users',
        'user_button_import': 'Import list of users',
        'user_button_create': 'Create user',
        'user_ns_paginate_filter_level': 'Filter by level',
        'user_ns_paginate_filter_level_placeholder': 'Filter by level',
        'user_ns_paginate_filter_level_option_superuser': 'Super user',
        'user_ns_paginate_filter_level_option_admin': 'Admin',
        'user_ns_paginate_filter_level_option_manager': 'Manager',
        'user_ns_paginate_filter_level_option_simple': 'Simple user',
        'user_ns_paginate_table_label_email': 'Email',
        'user_ns_paginate_table_label_first_name': 'First name',
        'user_ns_paginate_table_label_last_name': 'Last name',
        'user_ns_paginate_table_label_level': 'Level',
        'user_ns_paginate_table_label_groups': 'Groups',
        'user_ns_paginate_table_label_actions': 'Actions',
        'user_ns_paginate_table_label_actions_edit_tooltip': 'Edit user',
        'user_ns_paginate_table_label_actions_manage_group_tooltip': 'Manage user groups',
        'user_ns_paginate_table_label_actions_delete_not_available_tooltip': 'You can\'t delete users with level superior or equal to yours.',
        'user_ns_paginate_table_label_actions_delete_tooltip': 'Delete user',
        'user_ns_paginate_table_label_actions_manage_role_not_available_tooltip': 'You can\'t manage users role of users with level superior or equal to yours.',
        'user_ns_paginate_table_label_actions_manage_role_tooltip': 'Manage user roles',
        'user_ns_paginate_table_label_actions_edit_password_not_available_tooltip': 'You can\'t change the password of users with level superior or equal to yours.',
        'user_ns_paginate_table_label_actions_edit_password_no_password_tooltip': 'This user doesn\'t use a password',
        'user_ns_paginate_table_label_actions_edit_password_tooltip': 'Edit password',
        'user_strength_level_superuser': 'Super user',
        'user_strength_level_admin': 'Admin',
        'user_strength_level_manager': 'Manager',
        'user_strength_level_simple': 'Simple user',
        'user_strength_level_blocked': 'Blocked',
        'user_update_success_title': 'success',
        'user_update_success_message_beginnning': 'User',
        'user_unblock_success_message': 'User(s) unblocked',
        'user_update_success_message_end': 'and related groups has been updated.',
        'user_update_failure_title': 'error',
        'user_update_failure_message_beginnning': 'Error on user',
        'user_unblock_failure_message': 'Error on user unblock',
        'user_update_failure_message_end': 'update',
        'user_prompt_change_password_title': 'Change password',
        'user_prompt_change_password_message': 'New password',
        'user_prompt_change_password_message_check': 'Confirm password',
        'user_prompt_change_password_button_confirm': 'OK',
        'user_prompt_change_password_button_cancel': 'Cancel',
        'user_prompt_change_password_error': 'Password too short',
        'user_prompt_change_password_success_title': 'Password updated',
        'user_prompt_change_password_success_message': 'The password has been updated for',
        'user_prompt_change_password_failure_title': 'Change password failed',
        'user_prompt_change_password_failure_message': 'The password cannot be updated for',
        'user_creation_failure_title': 'error',
        'user_creation_failure_message': 'Error on create user',
        'user_deletion_warning_title': 'Warning',
        'user_deletion_warning_message': 'Are you sure you want to delete this user. Continue?',
        'user_deletion_warning_button_confirm': 'Yes',
        'user_deletion_warning_button_cancel': 'No',
        'user_deletion_success_title': 'User deleted',
        'user_deletion_success_message_beginning': 'User',
        'user_deletion_success_message_end': 'has been deleted',
        'user_deletion_failure_title': 'Error',
        'user_deletion_failure_message': 'Error on delete user',
        'user_modal_manage_group_title_beginning': 'Manage',
        'user_blocked_modal_title': 'Unblock users',
        'user_modal_manage_group_title_end': 'user groups',
        'user_modal_create_user_title': 'Create new user',
        'user_modal_import_users_title': 'Import users',
        'user_modal_edit_users_button_cancel': 'Cancel',
        'user_modal_edit_users_button_save': 'Save',
        'user_modal_edit_users_context_title_beginning': 'Manage',
        'user_modal_edit_users_context_title_end': 'user',
        'user_modal_edit_users_no_context_title': 'Create user',
        'user_modal_manage_user_roles_title_beginning': 'Manage',
        'user_modal_manage_user_roles_title_end': 'roles',
        'user_modal_manage_user_roles_transfer_from': 'Available roles',
        'user_modal_manage_user_roles_transfer_to': 'Selected roles',
        'user_modal_manage_user_roles_transfer_label': 'name',
        'user_modal_manage_user_roles_button_close': 'Close',
        'user_modal_manage_user_roles_button_save': 'Save',
        'user_modal_manage_user_roles_success_title': 'Success',
        'user_modal_manage_user_roles_success_message': 'User roles updated',
        'user_modal_manage_user_roles_failure_title': 'Error',
        'user_modal_manage_user_roles_failure_message': 'Error on user roles update',
        'user_action_radio_option_manager': 'Manager',
        'user_action_radio_option_simpleuser': 'Simple user',
        'user_action_radio_option_admin': 'Admin',
        'user_action_radio_option_blocked': 'Blocked',
        'user_action_radio_button': 'Send selection',
        'user_action_change_password': 'Change password',
        'user_action_upgrade_permission': 'Upgrade permission',
        'user_action_upgrade_permission_success_title': 'User permission updated',
        'user_action_upgrade_permission_success_message_beginning': 'The user status has been updated to',
        'user_action_upgrade_permission_success_message_end': 'for',
        'user_action_upgrade_permission_failure_title': 'User updated failed',
        'user_action_upgrade_permission_failure_message_beginning': 'The user status cannot be updated to',
        'user_action_upgrade_permission_failure_message_end': 'for',
        'user_action_remove_user_success': 'User removed from project',
        'user_action_remove_user_failure': 'User remove from project failed',
        'user_action_change_password_success_title': 'Password updated',
        'user_action_change_password_success_message': 'The password has been updated for',
        'user_action_change_password_failure_title': 'Change Password failed',
        'user_action_change_password_failure_message': 'The password cannot be updated for',

        // groups view
        'group_simple_layout_indicator_subtitle': 'group(s)',
        'group_simple_layout_indicator_breadcrumb': 'Groups Management',
        'group_page_title': 'Groups',
        'group_button_add_group': 'Add a group',
        'group_ns_paginate_label_group_name': 'Group name',
        'group_ns_paginate_label_members_number': 'Number of members',
        'group_ns_paginate_label_actions': 'Actions',
        'group_ns_paginate_actions_add_user_tooltip': 'Add user to group',
        'group_ns_paginate_actions_edit_group_tooltip': 'Edit group',
        'group_ns_paginate_actions_delete_group_tooltip': 'Delete group',
        'group_modal_manage_user_group_title_beginning': 'Manage',
        'group_modal_manage_user_group_title_end': 'users group',
        'group_modal_create_group_title': 'Create a group',
        'group_create_group_success_title': 'success',
        'group_create_group_success_message': 'Group created',
        'group_create_group_failure_title': 'error',
        'group_create_group_failure_message': 'Error on group creation',
        'group_deletion_prompt_title': 'Warning',
        'group_deletion_prompt_message_beginning': 'This will permanently delete',
        'group_deletion_prompt_message_end': 'group. Continue?',
        'group_deletion_prompt_button_confirm': 'OK',
        'group_deletion_prompt_button_cancel': 'Cancel',
        'group_deletion_success_title': 'success',
        'group_deletion_success_message': 'group has been deleted.',
        'group_deletion_failure_title': 'error',
        'group_deletion_failure_message': 'Error on group deletion.',
        'group_update_group_name_prompt_title': 'Update group name',
        'group_update_group_name_prompt_message': '',
        'group_update_group_name_prompt_button_confirm': 'OK',
        'group_update_group_name_prompt_button_cancel': 'Cancel',
        'group_update_group_name_prompt_error': 'Invalid group name',
        'group_update_group_name_success_title': 'success',
        'group_update_group_name_success_message_beginning': '',
        'group_update_group_name_success_message_end': 'group has been updated.',
        'group_update_group_name_failure_title': 'error',
        'group_update_group_name_failure_message_beginning': 'Error on',
        'group_update_group_name_failure_message_end': 'group update',
        'group_modal_form_label_name': 'Name',
        'group_modal_form_name_placeholder': 'Group name',
        'group_modal_form_label_members': 'Members',
        'group_modal_form_transfer_from': 'Available users',
        'group_modal_form_transfer_to': 'Users in group',
        'group_modal_form_transfer_placeholder': 'Select members',
        'group_modal_form_error_syntax': 'Group name accept only characters in lower case and uppercase, numbers and - ',
        'group_modal_form_error_name_taken': 'A group with this name already exist',

        // global
        // moment
        'moment_close_time': 'a few moments',
        'moment_one_minute': '1 minute',
        'moment_minutes': ' minutes',
        'moment_one_hour': '1 hour',
        'moment_hours': ' hours',
        'moment_one_day': '1 day',
        'moment_days': ' days',
        'moment_ago': ' ago',

        // dashboard defaults part's names
        'sidebar_default_name': 'Menu',
        'dashboard_default_name': 'Dashboard',
        'plateform_default_name': 'Platform',

        // password security
        'password_security_fetching_rules': 'Searching for rules',
        'password_security_fetch_no_rules': 'No rules availables',
        'password_security_fetch_rule_error': 'Server error, rules can\'t be fetched',


        // generic words
        'field_required': 'Field can\'t be empty.',
        'close': 'Close',
        'cancel': 'Cancel',
        'save': 'Save',
        'create': 'Create',
        'rules': 'Rules',

    },
    'fr': {
        // Auth component
        'token_timeout_info': 'Vous avez été déconnecté car votre jeton a expiré',
        'login': 'Authentification',
        'register': 'Inscription',
        'forgot_password': 'Mot de passe oublié',
        'login_tab_title': 'Connexion',
        'register_tab_title': 'Inscription',
        'forgot_password_tab_title': 'Mot de passe oublié',
        'login_by_email_tab_title': 'Connexion par email',
        'reset_password_title': 'Réinitialisation du mot de passe',
        'login_by_email': 'Veuillez saisir votre email.',
        'auth_field_email': 'Email',
        'auth_field_username': 'Nom d\'utilisateur',
        'auth_field_password': 'Mot de passe',
        'auth_field_password_confirmation': 'Confirmation du mot de passe',
        'auth_login_button': 'Se connecter',
        'auth_register_button': 'S\'enregistrer',
        'forgot_password_authentication_error_title': 'Erreur d\'authentification',
        'forgot_password_authentication_success_title': 'Succès',
        'forgot_password_button': 'Réinitialiser',
        'login_by_email_button': 'Se connecter',
        'login_by_email_info_button': 'Ok',
        'login_by_email_loading_text': 'Tentative de connexion',
        'login_by_email_email_error': 'Veuillez insérer une adresse email correcte',
        'reset_password_button': 'Confirmer',
        'login_field_forgot_password': 'Veuillez saisir votre email.',
        'login_at_least_one_field_empty': 'Veuillez renseigner tous les champs.',
        'login_email_incorrect': 'L\'adresse email est incorrecte',
        'login_password_empty': 'Le mot de passe n\'est pas renseigné.',
        'login_error_403': 'Vous n\'avez pas les permissions nécessaires, veuillez contacter un administrateur.',
        'login_error_0': 'Aucune réponse du serveur.',
        'login_error_401': 'Les informations d\'authentification fournies sont incorrectes.',
        'login_error_412': 'Vous vous êtes bien inscrit. Vous allez recevoir un email pour confirmer votre compte.',
        'login_please_fill_password': 'Veuillez saisir le mot de passe',
        'login_please_fill_email': 'Veuillez saisir l\'email',
        'login_please_fill_username': 'Veuillez saisir le nom d\'utilisateur',
        'login_password_reset_error': 'Aucun compte n\'est rattaché à cet email. Veuillez contacter un administrateur',
        'login_passwords_dont_match': 'Les mots de passe diffèrent',
        'login_password_reset_success': ' Un email vous a été envoyé sur votre adresse mail contenant un lien pour réinitialiser votre mot de passe',
        'login_validation_error': 'Erreur de validation',
        'login_please_correct_the_form': 'Veuillez corriger le formulaire',
        'login_please_fill_password_again': 'Veuillez saisir de nouveau le mot de passe',
        'auth_password_updated': 'Mot de passe mis à jour',
        'auth_password_update_error': 'Impossible de mettre à jour le mot de passe',
        'login_change_password': 'Changer mot de passe',
        'login_password_expired': 'Mot de passe expiré',
        'login_password_expired_message': 'Votre mot de passe a expiré. Veuillez saisir un nouveau mot de passe.',
        'login_EMAIL_NOT_AUTHORIZED_TO_REGISTER': 'Cet email n’est pas autorisé pour les inscriptions.',
        'login_EXPIRED_PASSWORD': 'Votre mot de passe a expiré.',
        'login_PASSWORD_INSECURE': 'Votre mot de passe doit comporter au minimum 8 caractères, 1 chiffre, 1 minuscule, 1 majuscule et 1 caractère spécial.',
        'login_EMAIL_NOT_VALIDATED': 'Votre compte n\'a pas été activé, un email d\'activation a été envoyé sur votre boîte mail.',
        'login_TOKEN_HAS_EXPIRED': 'Impossible de se connecter, votre session a expiré veuillez saisir votre email pour créer une nouvelle session.',
        'login_LOGIN_BY_EMAIL_MAIL_SEND': 'Vous avez reçu un email avec un lien de connexion.',
        'login_INVALID_TOKEN': 'Token invalide.',
        'login_WRONG_EMAIL_ADDRESS': 'L\'email renseigné n\'est pas autorisé à ce connecter à la plateforme.',
        'login_new_mfa_code_info': 'Une nouvelle connexion est requise pour recevoir un nouveau code par email',

        'mfa_title': 'Authentification à double facteurs',
        'mfa_code_input_label': 'Code de l\'authentification à double facteurs',
        'mfa_code_instruction': 'Entrez le code de l\'authentification à double facteurs reçu par email.',
        'mfa_code_error': 'Erreur',
        'mfa_submit_button': 'Verifier le code',
        'mfa_new_code_button': 'Demander un nouveau code',
        'mfa_input_validation_error': 'Veuillez insérer un code',

        // dashboard layout
        'alert_dismiss': 'Ignorer',
        'header_language_button': 'Langage',
        'sidebar_settings_menu': 'Options',
        'sidebar_alerts_menu': '   Alertes',
        'sidebar_alarms_menu': '    Alarmes',
        'sidebar_profile_menu': 'Profil',
        'sidebar_logout_menu': 'Déconnexion',
        'sidebar_users_menu': 'Utilisateurs',
        'sidebar_groups_menu': 'Groupes',
        'sidebar_permissions_menu': 'Permissions',
        'topBarAlert_update': 'Une mise à jour est disponible, veuillez rafraîchir la page ou <u class="link" onclick="window.location.reload()">cliquer ici</u>',
        'topBarAlert_offline': 'DÉCONNECTÉ : impossible de se connecter au serveur, veuillez vérifier votre connexion internet',
        'app_loader_text': 'CHARGEMENT',

        'page_no_permission': 'Vous n\'êtes pas autorisé(e) à accéder à cette page',

        // alarm component
        'alarm_info_title': 'Détails',
        'alarm_last_trigger': 'Dernier déclenchement il y a',
        'alarm_last_trigger_time': 'Dernier déclenchement',
        'alarm_last_active_time': 'Active depuis',
        'alarm_message_title': 'Message',
        'alarm_message_empty': 'Aucun message',
        'alarm_details_title': 'Détails',
        'alarm_details_empty': 'Aucun détails',
        'alarm_redirection_tooltip': 'Rediriger vers la ressource',
        'alarm_redirection_button': 'Aller à la ressource',
        'alarm_redirection_empty': 'Aucune ressource liée',
        'alarm_simple_layout_breadcrumb': 'Alarmes',
        'alarm_simple_layout_active_alarm_indicator': 'alarmes actives',
        'alarm_simple_layout_inactive_alarm_indicator': 'alarmes inactives',
        'alarm_empty': 'Aucune alarme disponible.',
        'alarm_filter_no_result': 'Aucune alarme pour ',
        'alarm_filter_select_option_all': 'Toutes les alarmes',
        'alarm_filter_select_option_active': 'Alarmes actives',
        'alarm_filter_select_option_inactive': 'Alarmes inactives',
        'alarm_no_permission': 'Vous n\'êtes pas autorisé(e) à accéder à la page des alarmes',
        'alarm_notification_message_beginning': 'Nouvelle alarme',
        'alarm_notification_message_end': 'déclenchée',

        // alert component
        'alert_simple_layout_breadcrumb': 'Alertes',
        'alert_simple_layout_active_alert_indicator': 'alertes actives',
        'alert_simple_layout_inactive_alert_indicator': 'alertes inactives',
        'alert_tab_panel_active_alert_title': 'Alertes actives',
        'alert_tab_panel_inactive_alert_title': 'Alertes inactives',
        'alert_tab_panel_archived_alert_title': 'Alertes archivées',
        'alert_no_permission': 'Vous n\'avez pas la permission d\'accéder à cette page.',
        'alert_table_label_name': 'Nom',
        'alert_table_label_acquitted': 'Temps depuis l\'acquittement',
        'alert_table_label_triggered': 'Dernier déclenchement',
        'alert_table_label_hits': 'Nombre de déclenchement',
        'alert_table_label_level': 'Niveau',
        'alert_table_label_message': 'Message',
        'alert_table_label_event': 'Evènement',
        'alert_table_event_not_found': 'Aucun évènement n\'a été trouvé',
        'alert_table_label_link': 'Lien vers la ressource',
        'alert_table_redirection_tooltip': 'Redirection vers la ressource',
        'alert_table_button_acquit': 'Acquitter l\'alerte',
        'alert_table_button_archive': 'Archiver l\'alerte',
        'alert_acquit_modal_text': 'Êtes-vous sûr de vouloir acquitter l\'alerte?',
        'alert_acquit_modal_title': 'Acquitter l\'alerte',
        'alert_acquit_modal_button_confirm': 'Oui',
        'alert_acquit_modal_button_cancel': 'Non',
        'alert_acquit_sucessfull': 'Acquittée.',
        'alert_acquit_failed': 'Opération annulée.',
        'alert_archive_modal_text': 'Êtes-vous sûr de vouloir archiver l\'alerte?',
        'alert_archive_modal_title': 'Archiver l\'alert',
        'alert_archive_modal_button_confirm': 'Oui',
        'alert_archive_modal_button_cancel': 'Non',
        'alert_archive_sucessfull': 'Archivée.',
        'alert_archive_failed': 'Opération annulée.',
        'alert_notification_message_beginning': 'Nouvelle alerte',
        'alert_notification_message_end': 'déclenchée',

        // profile component
        'profile_simple_layout_indicator_title': 'Vos paramètres de profil',
        'profile_simple_layout_breadcrumb': 'Profil',
        'profile_arrival_date': 'Arrivée',
        'profile_identity': 'Identité',
        'profile_identity_form_label_email': 'Email',
        'profile_identity_form_label_first_name': 'Prénom',
        'profile_identity_form_label_last_name': 'Nom de famille',
        'profile_save_button': 'Sauvegarder',
        'profile_identity_save_successfull_title': 'Édition terminée',
        'profile_identity_save_successfull_message': 'Votre profil à été mis à jour',
        'profile_identity_save_failed_title': 'Erreur d\'édition',
        'profile_identity_save_failed_message': 'Impossible de mettre à jour le profil',
        'profile_manage_notifications': 'Gérer les notifications',
        'profile_notification_form_label_unsubscribe': 'Se désabonner de toutes les notifications',
        'profile_notification_form_label_unsubscribe_yes': 'Oui',
        'profile_notification_form_label_unsubscribe_no': 'Non',
        'profile_notification_form_label_subscribe': 'S\'abonner à',
        'profile_notification_save_successfull_title': 'Notifications sauvegardées',
        'profile_notification_save_successfull_message': 'Les paramètres de notifications ont été mis à jour.',
        'profile_notification_save_failed_title': 'Erreur durant la mis à jour',
        'profile_notification_save_failed_message': 'Impossible de mettre à jour les paramètres de notification.',
        'profile_change_password_title': 'Changer le mot de passe',
        'profile_change_password_button': 'Changer le mot de passe',
        'profile_loading': 'chargement...',

        // search view
        'search_result_breadcrumb': 'Résultats de recherche',
        'search_result_no_result': 'Aucun résultat.',
        'search_result_loading': 'Chargement...',
        'search_result_pagename_single_result': ' résultat',
        'search_result_pagename_results': ' résultats',
        'search_result_pagename_no_result': 'Aucun résultat trouvé',
        'search_result_subtitle': 'Résultats de recherche pour: ',
        'search_result_subtitle_empty_request': 'Recherche vide.',

        // settings view
        'settings_breadcrumb': 'Paramètres',
        'settings_title': 'Paramètres',

        // sink handler view (error 404)
        'sink_handler_title': 'Erreur',
        'sink_handler_text': 'La page n\'existe pas',
        'sink_handler_loading': 'chargement...',

        // partials
        // dynamic form json
        'dynamic_form_json_new': 'Ajouter',
        'dynamic_form_json_save': 'Sauvegarder',
        'dynamic_form_json_reset': 'Réinitialiser',

        // nsPaginate component
        'ns_paginate_search_title': 'Filtre de recherche',
        'ns_paginate_search_placeholder': 'Chercher parmi les données du tableau',
        'ns_paginate_filters_title': 'Filtres',
        'new_ns_paginate_filters_input_placeholder': 'Entrer une valeur pour filtrer par',
        'new_ns_paginate_filters_select_placeholder': 'Choisissez parmi les différentes valeurs de',
        'ns_paginate_filters_button_reset': 'Réinitialiser les filtres',
        'new_ns_paginate_filters_button_reset': 'Réinitialiser',
        'ns_paginate_filters_button_apply': 'Appliquer les filtres',
        'new_ns_paginate_filters_button_apply': 'Appliquer',
        'ns_paginate_advanced_filters_switch_active_text': 'Filtres avancés',
        'ns_paginate_advanced_filters_description': 'Les filtres avancés n\'acceptent que des chiffres et des dates (dont le format doit être YYYY-MM-DD, ex: 2019-10-23. Pour les filtres utilisant des intervalles, les nombres doivent être séparés par des virgules.',
        'ns_paginate_advanced_filters_title': 'Info',
        'ns_paginate_advanced_filters_placeholder': 'Valeur à filtrer',
        'ns_paginate_advanced_filters_compare_placeholder': 'Élément de comparaison',
        'ns_paginate_advanced_filters_compare_gt': 'Supérieur à',
        'ns_paginate_advanced_filters_compare_gte': 'Supérieur ou égal à',
        'ns_paginate_advanced_filters_compare_lt': 'Inférieur à',
        'ns_paginate_advanced_filters_compare_lte': 'Inférieur ou égal à',
        'ns_paginate_advanced_filters_compare_range': 'Compris entre',
        'ns_paginate_advanced_filters_compare_input_placeholder': 'Valeur de comparaison',
        'ns_paginate_advanced_filters_compare_input_tip': 'Les nombres doivent être séparés par une virgule.',
        'ns_paginate_advanced_filters_error_message_type': 'Ce filtre ne peut être composé que de chiffres ou de dates.',
        'ns_paginate_advanced_filters_range_error_message_type': 'L\'intervalle doit suivre un des modèles suivants "YYYY-MM-DD,YYYY-MM-DD" ou "x,y"',
        'ns_paginate_advanced_filters_range_error_message_date': 'La première date doit être antérieure à la seconde.',
        'ns_paginate_advanced_filters_help_text': 'Ce filtre a été ignoré puisqu\'il était incomplet.',
        'ns_paginate_table_column_status_label': 'Status',
        'ns_paginate_table_column_operations_label': 'Opérations',
        'ns_paginate_table_column_edit_label': 'Actions',
        'ns_paginate_table_column_edit_tooltip': 'Editer',
        'ns_paginate_table_empty': 'Aucun contenu',
        'ns_paginate_modal_information_title': 'Détails',
        'ns_paginate_modal_information_edit_props_error': 'LES PROPS DU MODÈLE DOIVENT ÊTRE FOURNIS POUR MODIFIER L\'OBJET',
        'ns_paginate_modal_information_edit_success_title': 'Modification terminée',
        'ns_paginate_modal_information_edit_success_desc': 'Vos modification ont été enregistrées',
        'ns_paginate_modal_information_edit_error_title': 'Erreur dans la modification',
        'ns_paginate_modal_information_edit_error_desc': 'Vos modification \'ont pas pu être enregistrées',
        'ns_paginate_modal_detail_tooltip_preview': 'Prévisualisation',
        'ns_paginate_modal_detail_tooltip_edit': 'Modifier',
        'ns_paginate_modal_detail_item_empty': 'Non créé',
        'ns_paginate_csv_button': 'Télécharger le CSV',

        // waiting button
        'waiting_button_message_confirmation_title': 'Attention',
        'waiting_button_message_confirmation_button': 'OK',
        'waiting_button_message_confirmation_cancel_button': 'Annuler',

        // logs components
        'table_column_label_level': 'Niveau',
        'table_column_label_date': 'Date',
        'table_column_label_message': 'Message',

        // modal form components
        'modal_form_loading': 'Chargement...',
        'modal_form_confirm_button_text': 'Sauvegarder',

        // ns loader
        'ns_loader_loading': 'chargement',
        'ns_loader_content': 'Contenu',

        // simple layout
        'simple_layout_loading': 'chargement...',

        // sort by drag and drop
        'drag_and_drop_tip': 'Déplacez pour réarranger',
        'drag_and_drop_error_title': 'Erreur',
        'drag_and_drop_error_message': 'Erreur durant le réarrangement',

        // permissions management
        'permissions_simple_layout_breadcrumb': 'Gestion des permissions',
        'permissions_table_column_label_roles': 'Gestion des rôles',
        'permissions_table_column_label_models': 'Gestion des modèles de permission',
        'permissions_alert_no_roles_title': 'Aucun rôle disponible',
        'permissions_alert_no_roles_desc': 'Veuillez créer un rôle dans l\'onglet de gauche',
        'permissions_title': 'Mettre à jour les permissions des rôles sur les modèles',
        'permissions_roles_main_column_label': 'Nom des modèles',
        'permissions_roles_create_column_label': 'Création',
        'permissions_roles_delete_column_label': 'Suppression',
        'permissions_roles_update_column_label': 'Mis à jour',
        'permissions_roles_retrieve_column_label': 'Récupération',
        'permissions_save_button': 'Sauvegarder les permissions',
        'permissions_update_successfull_message': 'Permissions sauvegardées',
        'permissions_select_roles': 'Sélectionner le(s) rôle(s)',

        'permissions_role_creation_form_title_create': 'Créer un rôle',
        'permissions_role_creation_form_title_edit': 'Éditer un rôle',
        'permissions_role_creation_form_label_name': 'Nom du rôle',
        'permissions_role_creation_form_label_users': 'Utilisateur(s) avec ce rôle',
        'permissions_role_creation_form_transfer_left_label': 'Utilisateur(s) disponible(s)',
        'permissions_role_creation_form_transfer_right_label': 'Utilisateur(s) sélectionné(s)',
        'permissions_role_creation_button_cancel': 'Annuler',
        'permissions_role_creation_button_save': 'Sauvegarder',
        'permissions_role_creation_button': 'Créer un rôle',
        'permissions_role_table_column_name': 'Nom',
        'permissions_role_table_column_actions': 'Opérations',
        'permissions_role_save_successfull_title': 'Succès',
        'permissions_role_save_successfull_message_role': 'Rôle',
        'permissions_role_save_successfull_message_edited': 'édité',
        'permissions_role_save_successfull_message_created': 'créé',
        'permissions_role_save_failed_title': 'Erreur',
        'permissions_role_save_failed_message_role': 'du rôle',
        'permissions_role_save_failed_message_edited': 'Erreur sur l\'édition',
        'permissions_role_save_failed_message_created': 'Erreur sur la création',
        'permissions_user_retrieval_error': 'Erreur durant la récupération des utilisateurs',
        'permissions_role_deletion_title': 'Attention',
        'permissions_role_deletion_message': 'Cela supprimera ce rôle de manière permanente. Continuer?',
        'permissions_role_deletion_button_confirm': 'OK',
        'permissions_role_deletion_button_cancel': 'Annuler',
        'permissions_role_deletion_success_title': 'Succès',
        'permissions_role_deletion_success_message': 'Rôle supprimé',
        'permissions_role_deletion_failure_title': 'Erreur',
        'permissions_role_deletion_failure_message': 'Erreur durant la suppression du rôle',

        // user view
        'user_simple_layout_indicator_subtitle': 'utilisateur(s)',
        'user_creation_form_label_email': 'Email de l\'utilisateur',
        'user_creation_form_first_name': 'Prénom de l\'utilisateur',
        'user_creation_form_last_name': 'Nom de l\'utilisateur',
        'user_creation_form_label_groups': 'Groupes',
        'user_groups_edit_form_label_groups': 'Groupes',
        'user_blocked_form_label_groups': 'Utilisateurs bloqués',
        'user_groups_edit_form_transfer_from': 'Groupes disponibles',
        'user_blocked_form_transfer_from': 'Utilisateurs bloqués',
        'user_groups_edit_form_transfer_to': 'Groupes de l\'utilisateur',
        'user_blocked_form_transfer_to': 'Utilisateurs qui seront débloqués',
        'user_groups_edit_filter_placeholder': 'Sélectionner les groupes',
        'user_blocked_filter_placeholder': 'Sélectionner les utilisateurs',
        'user_groups_edit_validator_error': 'Veuillez valider vos changements ou déselectionner vos choix dans les deux tableaux.',
        'user_create_success_title': 'Utilisateur créé avec succès',
        'user_edit_form_label_level': 'Niveau',
        'user_edit_form_label_level_placeholder': 'Niveau de l\'utilisateur',
        'user_edit_alert_management_not_available': 'Vous ne pouvez gérer que les utilisateurs ayant un niveau strictement inférieur au votre.',
        'user_edit_form_label_preview': 'Aperçu uniquement',
        'user_edit_form_label_preview_active': 'Oui',
        'user_edit_form_label_preview_inactive': 'Non',
        'user_edit_form_level_option_superuser': 'Super utilisateur',
        'user_edit_form_level_option_admin': 'Administrateur',
        'user_edit_form_level_option_manager': 'Manager',
        'user_edit_form_level_option_simple': 'Simple utilisateur',
        'user_edit_form_level_option_blocked': 'Bloqué',
        'user_edit_success_title': 'Utilisateur modifié',
        'user_edit_success_message_beginning': 'L\'utilisateur',
        'user_edit_success_message_end': 'a été modifié.',
        'user_edit_failure_title': 'Erreur',
        'user_edit_success_message': 'Erreur durant la modification de l\'utilisateur',
        'user_import_modal_uploading': 'Analyse du fichier...',
        'user_import_modal_importing_error': 'Erreur lors de l\'analyse du fichier',
        'user_import_form_label_users': 'Utilisateurs',
        'user_import_form_label_groups': 'Groupes',
        'user_import_help_text': 'Ajouter plusieurs utilisateurs dans le même groupe en important un fichier csv/txt',
        'user_import_drop_file_text': 'Déposer un ficher ici ou ',
        'user_import_drop_file_text_emphasized': 'cliquer pour téléverser un fichier',
        'user_import_drop_file_tip': 'fichiers csv/txt ayant une taille inférieure à 500kB',
        'user_import_api_not_supported': 'Les API Files ne sont pas complètement supportées dans ce navigateur.',
        'user_import_email_not_valid': 'n\'est pas un email valide',
        'user_simple_layout_breadcrumb': 'Gestion des utilisateurs',
        'user_page_title': 'Utilisateurs',
        'user_button_import': 'Importer une liste d\'utilisateurs',
        'user_button_create': 'Créer un utilisateur',
        'user_ns_paginate_filter_level': 'Fitrer par niveau',
        'user_ns_paginate_filter_level_placeholder': 'Fitrer par niveau',
        'user_ns_paginate_filter_level_option_superuser': 'Super utilisateur',
        'user_ns_paginate_filter_level_option_admin': 'Administrateur',
        'user_ns_paginate_filter_level_option_manager': 'Manager',
        'user_ns_paginate_filter_level_option_simple': 'Simple utilisateur',
        'user_ns_paginate_table_label_email': 'Email',
        'user_ns_paginate_table_label_first_name': 'Prénom',
        'user_ns_paginate_table_label_last_name': 'Nom',
        'user_ns_paginate_table_label_level': 'Niveau',
        'user_ns_paginate_table_label_groups': 'Groupes',
        'user_ns_paginate_table_label_actions': 'Opérations',
        'user_ns_paginate_table_label_actions_edit_tooltip': 'Éditer un utilisateur',
        'user_ns_paginate_table_label_actions_manage_group_tooltip': 'Gérer les groupes d\'utilidateur',
        'user_ns_paginate_table_label_actions_delete_not_available_tooltip': 'Vous ne pouvez supprimez des utilisateurs dont le niveau est supérieur ou égal au votre',
        'user_ns_paginate_table_label_actions_delete_tooltip': 'Supprimez l\'utilisateur',
        'user_ns_paginate_table_label_actions_manage_role_not_available_tooltip': 'Vous ne pouvez gérer les rôles des utilisateurs dont le niveau est supérieur ou égal au votre',
        'user_ns_paginate_table_label_actions_manage_role_tooltip': 'Gérer les rôles d\'un utilisateur',
        'user_ns_paginate_table_label_actions_edit_password_not_available_tooltip': 'Vous ne pouvez gérer le mot de passe des utilisateurs dont le niveau est supérieur ou égal au votre',
        'user_ns_paginate_table_label_actions_edit_password_no_password_tooltip': 'Cet utilisateur n\'a pas d\'authentification avec un mot de passe',
        'user_ns_paginate_table_label_actions_edit_password_tooltip': 'Modifier un mot de passe',
        'user_strength_level_superuser': 'Super utilisateur',
        'user_strength_level_admin': 'Administrateur',
        'user_strength_level_manager': 'Manager',
        'user_strength_level_simple': 'Simple utilisateur',
        'user_strength_level_blocked': 'Bloqué',
        'user_update_success_title': 'succès',
        'user_unblock_success_message': 'Utilisateur(s) débloqué(s)',
        'user_update_success_message_beginnning': 'L\'utilisateur',
        'user_update_success_message_end': 'et ses groupes ont bien été modifiés.',
        'user_update_failure_title': 'erreur',
        'user_update_failure_message_beginnning': 'Erreur sur la modification de l\'utilisateur',
        'user_unblock_failure_message': 'Erreur lors du déblocages de ces utilisateurs',
        'user_update_failure_message_end': '',
        'user_prompt_change_password_title': 'Modifier le mot de passe',
        'user_prompt_change_password_message': 'Nouveau mot de passe',
        'user_prompt_change_password_message_check': 'Confirmer mot de passe',
        'user_prompt_change_password_button_confirm': 'OK',
        'user_prompt_change_password_button_cancel': 'Annuler',
        'user_prompt_change_password_error': 'Mot de passe trop court',
        'user_prompt_change_password_success_title': 'Mot de passe modifié',
        'user_prompt_change_password_success_message': 'Le mot de passe a été modifié pour l\'utilisateur',
        'user_prompt_change_password_failure_title': 'La modification a échoué',
        'user_prompt_change_password_failure_message': 'Le mot de passe n\'a pas pu être modifié pour l\'utilisateur',
        'user_creation_failure_title': 'erreur',
        'user_creation_failure_message': 'Erreur lors de la création de l\'utilisateur',
        'user_deletion_warning_title': 'Attention',
        'user_deletion_warning_message': 'Êtes vous sûre de vouloir supprimer cet utilisateur. Continuer?',
        'user_deletion_warning_button_confirm': 'Oui',
        'user_deletion_warning_button_cancel': 'Non',
        'user_deletion_success_title': 'Utilisateur supprimé',
        'user_deletion_success_message_beginning': 'L\'utilisateur',
        'user_deletion_success_message_end': 'a été supprimé',
        'user_deletion_failure_title': 'Erreur',
        'user_deletion_failure_message': 'Erreur durant la suppression de l\'utilisateur',
        'user_modal_manage_group_title_beginning': 'Gérer les groupes de l\'utilisateur ',
        'user_blocked_modal_title': 'Débloquer utilisateurs',
        'user_modal_manage_group_title_end': '',
        'user_modal_create_user_title': 'Créer un nouvel utilisateur',
        'user_modal_import_users_title': 'Importer des utilisateurs',
        'user_modal_edit_users_button_cancel': 'Annuler',
        'user_modal_edit_users_button_save': 'Sauvegarder',
        'user_modal_edit_users_context_title_beginning': 'Gérer l\'utilisateur',
        'user_modal_edit_users_context_title_end': '',
        'user_modal_edit_users_no_context_title': 'Création d\'un utilisateur',
        'user_modal_manage_user_roles_title_beginning': 'Gérer les rôles de',
        'user_modal_manage_user_roles_title_end': '',
        'user_modal_manage_user_roles_transfer_from': 'Rôles disponibles',
        'user_modal_manage_user_roles_transfer_to': 'Rôles sélectionnés',
        'user_modal_manage_user_roles_transfer_label': 'nom',
        'user_modal_manage_user_roles_button_close': 'Fermer',
        'user_modal_manage_user_roles_button_save': 'Sauvegarder',
        'user_modal_manage_user_roles_success_title': 'Succès',
        'user_modal_manage_user_roles_success_message': 'Rôles de l\'utilisateur sauvegardés',
        'user_modal_manage_user_roles_failure_title': 'Erreur',
        'user_modal_manage_user_roles_failure_message': 'Erreur durant la modification des rôles de l\'utilisateur',
        'user_action_radio_option_manager': 'Manager',
        'user_action_radio_option_simpleuser': 'Simple utilisateur',
        'user_action_radio_option_admin': 'Administrateur',
        'user_action_radio_option_blocked': 'Bloqué',
        'user_action_radio_button': 'Envoyer la sélection',
        'user_action_change_password': 'Changer le mot de passe',
        'user_action_upgrade_permission': 'Améliorer les permissions',
        'user_action_upgrade_permission_success_title': 'Permissions de l\'utilisateur modifiées',
        'user_action_upgrade_permission_success_message_beginning': 'Le statut a été modifié en',
        'user_action_upgrade_permission_success_message_end': 'pour',
        'user_action_upgrade_permission_failure_title': 'La modification a échoué',
        'user_action_upgrade_permission_failure_message_beginning': 'Le statut n\'a pas pu être modifié en',
        'user_action_upgrade_permission_failure_message_end': 'pour',
        'user_action_remove_user_success': 'Retrait de l\'utilisateur du projet',
        'user_action_remove_user_failure': 'Le retrait de l\'utilisateur du projet a échoué',
        'user_action_change_password_success_title': 'Mot de passe modifié',
        'user_action_change_password_success_message': 'Le mot de passe a été modifié pour',
        'user_action_change_password_failure_title': 'La modification du mot de passe a échoué',
        'user_action_change_password_failure_message': 'Le mot de passe n\'a pas pu être modifié pour',

        // groups view
        'group_simple_layout_indicator_subtitle': 'groupe(s)',
        'group_simple_layout_indicator_breadcrumb': 'Gestion des groupes',
        'group_page_title': 'Groupes',
        'group_button_add_group': 'Ajouter un groupe',
        'group_ns_paginate_label_group_name': 'Nom du groupe',
        'group_ns_paginate_label_members_number': 'Nombre de membre',
        'group_ns_paginate_label_actions': 'Opérations',
        'group_ns_paginate_actions_add_user_tooltip': 'Ajouter un utilisateur au groupe',
        'group_ns_paginate_actions_edit_group_tooltip': 'Modifier le groupe',
        'group_ns_paginate_actions_delete_group_tooltip': 'Supprimer le groupe',
        'group_modal_manage_user_group_title_beginning': 'Gérer les membres du groupe',
        'group_modal_manage_user_group_title_end': '',
        'group_modal_create_group_title': 'Créer un groupe',
        'group_create_group_success_title': 'succès',
        'group_create_group_success_message': 'Groupe créé',
        'group_create_group_failure_title': 'erreur',
        'group_create_group_failure_message': 'Erreur durant la création du groupe',
        'group_deletion_prompt_title': 'Attention',
        'group_deletion_prompt_message_beginning': 'Cela supprimera définitivement le groupe',
        'group_deletion_prompt_message_end': '. Continuer?',
        'group_deletion_prompt_button_confirm': 'OK',
        'group_deletion_prompt_button_cancel': 'Annuler',
        'group_deletion_success_title': 'succès',
        'group_deletion_success_message': 'a été supprimé.',
        'group_deletion_failure_title': 'erreur',
        'group_deletion_failure_message': 'Erreur sur la suppression du gruope.',
        'group_update_group_name_prompt_title': 'Modifier le nom du groupe',
        'group_update_group_name_prompt_message': '',
        'group_update_group_name_prompt_button_confirm': 'OK',
        'group_update_group_name_prompt_button_cancel': 'Annuler',
        'group_update_group_name_prompt_error': 'Nom de groupe invalide',
        'group_update_group_name_success_title': 'succès',
        'group_update_group_name_success_message_beginning': 'le groupe',
        'group_update_group_name_success_message_end': 'a été modifié.',
        'group_update_group_name_failure_title': 'erreur',
        'group_update_group_name_failure_message_beginning': 'Erreur durant la modification du groupe',
        'group_update_group_name_failure_message_end': '',
        'group_modal_form_label_name': 'Nom',
        'group_modal_form_name_placeholder': 'Nom du groupe',
        'group_modal_form_label_members': 'Membres',
        'group_modal_form_transfer_from': 'Utilisateurs disponibles',
        'group_modal_form_transfer_to': 'Utilisateurs présent',
        'group_modal_form_transfer_placeholder': 'Sélectionner les membres',
        'group_modal_form_error_syntax': 'Le nom du groupe n\'accepte que les caractères minuscules et majuscules, les nombres et les - ',
        'group_modal_form_error_name_taken': 'Un groupe avec ce nom existe déjà',

        // global
        // moment
        'moment_close_time': 'Il y a peu de temps',
        'moment_one_minute': '1 minute',
        'moment_minutes': ' minutes',
        'moment_one_hour': '1 heure',
        'moment_hours': ' heures',
        'moment_one_day': '1 jour',
        'moment_days': ' jours',
        'moment_ago': 'depuis ',

        // dashboard defaults part's names
        'sidebar_default_name': 'Menu',
        'dashboard_default_name': 'Tableau de bord',
        'plateform_default_name': 'Plateforme',


        // password security
        'password_security_fetching_rules': 'Recherche des règles',
        'password_security_fetch_no_rules': 'Aucune règle disponnibles',
        'password_security_fetch_rule_error': 'Erreur serveur, les règles ne peuvent pas être récupéré',



        // generic words
        'field_required': 'Ce champ ne peux pas être vide.',
        'close': 'Fermer',
        'cancel': 'Annuler',
        'save': 'Enregistrer',
        'create': 'Créer',
        'rules': 'Règles',
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/store/lang.js
// module id = null
// module chunks = 